import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { useBrand } from '@atc/brand';
import { BrowserStorage } from '@atc/browser-storage';
import { useFeatures } from '@atc/features';
import { ClientOnly } from '@atc/react-client-only';

import cbhVehicleInterestsDuck from '@/ducks/cbhVehicleInterestsDuck.js';

import stillInterestedAlertBeacon from '@/fetchers/StillInterestedAlertBeacon';

import StillInterestedAlert from './StillInterestedAlert';

function SrpAlertsContainer() {

    const {
        active_deals_my_wallet: [enableActiveDeals],
        show_wallet_alert_notification: [showWalletAlertNotification],
        still_interested_alert: [enableStillInterestedAlert],
        still_interested_alert_beacon: [enableStillInterestedAlertBeacon],
    } = useFeatures([
        'active_deals_my_wallet',
        'show_wallet_alert_notification',
        'still_interested_alert',
        'still_interested_alert_beacon',
    ]);

    const { brand, brands } = useBrand();
    const { ATC_BRAND, KBB_BRAND } = brands;

    // wallet alerts and browser notifcation prompt local storage values
    const walletNotifCache = new BrowserStorage('WALLET_NOTIF_POPOVER', { persist: true });
    const stillInterestedVehicle = useSelector((state) => cbhVehicleInterestsDuck.selectors.getFirstVehicle(state));

    const stillInterestedVehiclesCache = new BrowserStorage('STILL_INTERESTED_VEHICLES', { persist: true });
    const cachedStillInterestedVehicles = stillInterestedVehiclesCache.getItem() || [];

    const cbhStillInterestedVehicles = (useSelector(cbhVehicleInterestsDuck.selectors.getSortedVehicles) || []).slice(0, 10);

    const alertEnabled = (showWalletAlertNotification && enableActiveDeals);
    const showWalletAlert = alertEnabled && walletNotifCache.getItem()?.show;
    const showStillInterested = enableStillInterestedAlert && stillInterestedVehicle;

    useEffect(() => {
        if (enableStillInterestedAlertBeacon) {
        // check if we have new cbh still interested vehicles loaded
            let isEqual = true;
            for (let i = 0; i < cbhStillInterestedVehicles.length; i++) {
                if (cbhStillInterestedVehicles[i].id !== cachedStillInterestedVehicles[i]) {
                    isEqual = false;
                    break;
                }
            }

            if (!isEqual) {
                (async () => {
                    const { default: importAuthUtilityBundle } = await import('@/utilities/importAuthUtilityBundle');
                    const { isUserSignedIn, getConsumerId, getUserAttributes } = await importAuthUtilityBundle();

                    let consumerId = null;
                    let email = null;

                    if (await isUserSignedIn()) {
                        consumerId = await getConsumerId().catch((_) => null);
                        const userAttributes = await getUserAttributes();
                        email = userAttributes?.email;
                    }

                    // beacon the request
                    if ([ATC_BRAND, KBB_BRAND].includes(brand) && (consumerId || email)) {
                        stillInterestedAlertBeacon({
                            brand: brand === ATC_BRAND ? 'AT' : 'KBB',
                            vins: cbhStillInterestedVehicles.map((listing) => listing.vin),
                            consumerId,
                            email,
                        });
                    }
                })();
                // update cache
                stillInterestedVehiclesCache.setItem(cbhStillInterestedVehicles.map((listing) => listing.id));
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cbhStillInterestedVehicles]);

    return (
        <ClientOnly className="padding-horizontal-2 padding-horizontal-sm-0">
            {(!showWalletAlert && showStillInterested) && (
                <StillInterestedAlert
                    stillInterestedVehicle={stillInterestedVehicle}
                />
            )}
        </ClientOnly>
    );
}

export default SrpAlertsContainer;
